import { PixelStreaming } from '@epicgames-ps/lib-pixelstreamingfrontend-ue5.5'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { useCallback, useState } from 'react'
import type { KestrelGatekeeper } from 'types'

const TEMPERATURE_PROBE_TIMEOUT_MS = 3000

const shouldHandleTemperatureProbe = (
  event: MouseEvent,
  selectedMode: string
): boolean => {
  return selectedMode === 'temperature' && event.button === 2
}

interface UseTemperatureProbeProps {
  pixelStreaming?: PixelStreaming
  selectedMode: string
  gatekeeper: KestrelGatekeeper
}

export const useTemperatureProbe = ({
  pixelStreaming,
  selectedMode,
  gatekeeper,
}: UseTemperatureProbeProps) => {
  const [temperatureProbeLoading, setTemperatureProbeLoading] = useState(false)

  const handleTemperatureProbe = useCallback(
    (event: MouseEvent) => {
      if (!pixelStreaming) return

      if (shouldHandleTemperatureProbe(event, selectedMode)) {
        event.preventDefault()
        event.stopPropagation()

        setTemperatureProbeLoading(true)

        if (gatekeeper.feature.temperatureProbeUsesCursorData) {
          pixelStreaming.emitUIInteraction({
            command: KestrelCommands.GET_CURSOR_DATA,
          })
        } else {
          pixelStreaming.emitUIInteraction({
            command: KestrelCommands.REQUEST_TEMPERATURE_PROBE,
          })
        }

        setTimeout(() => {
          setTemperatureProbeLoading(false)
        }, TEMPERATURE_PROBE_TIMEOUT_MS)
      }
    },
    [pixelStreaming, selectedMode, gatekeeper]
  )

  return {
    temperatureProbeLoading,
    setTemperatureProbeLoading,
    handleTemperatureProbe,
  }
}
